import { render, staticRenderFns } from "./TransportOrderCtEdit.vue?vue&type=template&id=9b4dc2ce&scoped=true"
import script from "./TransportOrderCtEdit.vue?vue&type=script&lang=js"
export * from "./TransportOrderCtEdit.vue?vue&type=script&lang=js"
import style0 from "./TransportOrderCtEdit.vue?vue&type=style&index=0&id=9b4dc2ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4dc2ce",
  null
  
)

export default component.exports